export default __webpack_public_path__ + "static/media/phoneVerification.a78b811b.svg";